import { GlobalLoader } from './globalLoader';

export const AppLoaders = () => {
	return (
		<>
			<GlobalLoader />
		</>
	);
};
